import i18n from "i18next";
import { initReactI18next} from "react-i18next";
import translationEN from "./locales/translation.en.json";
import translationFR from "./locales/translation.fr.json";
import translationDE from "./locales/translation.de.json";

import sharedTranslationEN from "../shared/my_account_button/locales/translation.en.json";
import sharedTranslationFR from "../shared/my_account_button/locales/translation.fr.json";
import sharedTranslationDE from "../shared/my_account_button/locales/translation.de.json";

const resources = {
    fr: {
        translation: {
            ...translationFR,
            ...sharedTranslationFR
        }
    },
    en: {
        translation: {
            ...translationEN,
            ...sharedTranslationEN
        }    },
    de: {

        translation: {
            ...translationDE,
            ...sharedTranslationDE
        }    }
};
i18n
    .use(initReactI18next)
    .init({
    resources,
    lng: "en",
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
        escapeValue: false // react already safes from xss
    }
});

export default i18n;